import React from 'react';
import { useRouter } from 'next/router';
import Button, {
  Theme,
  Size,
} from '@havenengineering/module-shared-library/dist/components/Button/Button';
import styles from './no-results.module.scss';
import asset from '../../../../helpers/assets';
import Icon from '../../widget/icon';
import { Query } from '../../../../types/v2/holiday-search';
import useStepSelections from '../../../../hooks/useStepSelections';
import { useJourneySteps } from '../../../../hooks/useJourneySteps';
import { deleteQueryProperties, getFieldsAfterStep, getStep } from '../../../../helpers/redirects';
import { handleNoResultsNavigation } from '../../../../helpers/gtm/gtm-aggregating-journey';

type Props = {
  description?: string;
  activeStep: string;
  query: Query;
};

const NoResults = ({ description, activeStep, query }: Props) => {
  const { push } = useRouter();

  const defaultDescription = 'There is no availability for the chosen break at this time.';

  const { stepsWithSelections } = useStepSelections(query);
  const filteredSteps = stepsWithSelections?.filter((step) => step.title);
  const pathname = filteredSteps[0]?.pathName ? filteredSteps[0]?.pathName : '';
  const name = filteredSteps[0]?.name?.toLowerCase() || '';

  const journeySteps = useJourneySteps(undefined, query);

  const handleButtonClick = () => {
    handleNoResultsNavigation(activeStep?.toLowerCase() || '', name.toLowerCase());

    const previousStep = getStep(journeySteps, pathname);
    const fieldsAfterStep = getFieldsAfterStep(journeySteps, previousStep);

    const properties = fieldsAfterStep.map((step) => step?.name);
    const updatedQuery = deleteQueryProperties(query, properties as string[], [
      'parkCode',
      'parks',
      'arrivalDate',
      'duration',
      'packageType',
    ]);

    push({
      pathname,
      query: {
        ...updatedQuery,
        referringStep: activeStep?.toLowerCase(),
      },
    });
  };

  return (
    <div className={styles.noResults} data-testid="noResults">
      <Icon
        className={styles.illustration}
        src={asset('icecream.svg')}
        alt=""
        role="presentation"
      />
      <Icon src={asset('sorry.svg', 'images')} alt="Sorry!" />
      <p className={styles.description}>{description || defaultDescription}</p>
      <Button
        className={styles.button}
        theme={Theme.PRIMARY_THEME}
        scale={Size.LARGE_SIZE}
        block
        onClick={handleButtonClick}
      >
        Search again
      </Button>
    </div>
  );
};

export default NoResults;
